import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { ToastContext } from '../../contextStore/ToastContext';
import './InfoPages.css';

function ContactUs() {
  const { t } = useTranslation();
  const { addToast } = useContext(ToastContext);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder: in production would send to backend or email service
    addToast(t('contactUs.messageSent'), 'success');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>{t('contactUs.title')}</h1>
          <p>{t('contactUs.description')}</p>
        </div>

        <div className="infoSection">
          <h2>{t('contactUs.sendMessage')}</h2>
          <form className="infoForm" onSubmit={handleSubmit}>
            <label htmlFor="contact-name">{t('contactUs.name')}</label>
            <input
              id="contact-name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder={t('contactUs.namePlaceholder')}
            />
            <label htmlFor="contact-email">{t('contactUs.email')}</label>
            <input
              id="contact-email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder={t('contactUs.emailPlaceholder')}
            />
            <label htmlFor="contact-subject">{t('contactUs.subject')}</label>
            <select
              id="contact-subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            >
              <option value="">{t('contactUs.selectSubject')}</option>
              <option value="general">{t('contactUs.subjectGeneral')}</option>
              <option value="support">{t('contactUs.subjectSupport')}</option>
              <option value="safety">{t('contactUs.subjectSafety')}</option>
              <option value="business">{t('contactUs.subjectBusiness')}</option>
              <option value="other">{t('contactUs.subjectOther')}</option>
            </select>
            <label htmlFor="contact-message">{t('contactUs.message')}</label>
            <textarea
              id="contact-message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder={t('contactUs.messagePlaceholder')}
            />
            <button type="submit" className="infoBtn">
              {t('contactUs.sendMessage')}
            </button>
          </form>
        </div>

        <div className="infoSection">
          <h2>{t('contactUs.otherWays')}</h2>
          <p>
            <strong>{t('contactUs.support')}:</strong> {t('contactUs.supportDesc')}
          </p>
          <p>
            <strong>{t('contactUs.office')}:</strong> {t('contactUs.officeDesc')}
          </p>
          <p>
            <strong>{t('contactUs.social')}:</strong> {t('contactUs.socialDesc')}
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactUs;
